import dayjs from 'dayjs';

export const PERIOD_CHART_TITLES = {
  hour: 'Запросы по часам',
  day: 'Запросы по дням',
  month: 'Запросы по месяцам',
  year: 'Запросы по годам',
};

export const PERIOD_CHART_HINTS = {
  hour: 'Каждый столбец — один час. Цвета — категории поиска (ТЗ, заявки и WIPO объединены по вкладкам).',
  day: 'Каждый столбец — один календарный день. Цвета — категории поиска.',
  month: 'Каждый столбец — один месяц. Цвета — категории поиска.',
  year: 'Каждый столбец — один год. Цвета — категории поиска.',
};

export function periodUnit(period) {
  if (period === 'hour') return 'hour';
  if (period === 'month') return 'month';
  if (period === 'year') return 'year';
  return 'day';
}

export function formatChartPeriod(ts, period = 'day') {
  if (!ts) return '';
  const d = new Date(ts);
  if (period === 'hour') {
    return d.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
    });
  }
  if (period === 'month') {
    return d.toLocaleDateString('ru-RU', { month: 'short', year: 'numeric' });
  }
  if (period === 'year') return d.getFullYear().toString();
  return d.toLocaleDateString('ru-RU');
}

export function buildPeriodBuckets(dateFrom, dateTo, period = 'day') {
  if (!dateFrom || !dateTo) return [];
  const unit = periodUnit(period);
  let cur = dayjs(dateFrom).startOf(unit);
  const end = dayjs(dateTo).endOf(unit);
  const buckets = [];

  while (cur.isBefore(end) || cur.isSame(end, unit)) {
    const ts = cur.toDate().toISOString();
    buckets.push({
      ts,
      sortKey: cur.valueOf(),
      label: formatChartPeriod(ts, period),
    });
    cur = cur.add(1, unit);
  }
  return buckets;
}

export function bucketKeyForTs(ts, period = 'day') {
  return dayjs(ts).startOf(periodUnit(period)).valueOf();
}
